import React from 'react';
import { useIntl } from 'react-intl';
import { PAUSE_AUDIO_TEXT, PLAY_AUDIO_TEXT } from './audio-wave.text';
import { AudioWaveTrack } from './audio-wave-track';
import { useWaveSurfer } from './use-wave-surfer';

import './audio-wave.scss';

interface IAudioWaveProps {
    src?: string;
    blob?: Blob | null;
}

const AudioWave = ({ src, blob }: IAudioWaveProps) => {
    const intl = useIntl();
    const {
        waveRef,
        isPlaying,
        playbackSeconds,
        durationSeconds,
        hasWave,
        togglePlay,
    } = useWaveSurfer({ src: src, blob: blob });
    const playbackDisabled = !src && !blob;
    const showPlaybackPosition = isPlaying || (playbackSeconds > 0 && playbackSeconds < durationSeconds);

    return (
        <div className='audio-wave audio-wave--playback'>
            <AudioWaveTrack
                waveRef={waveRef}
                isPlaying={isPlaying}
                hasWave={hasWave}
                seconds={showPlaybackPosition ? playbackSeconds : durationSeconds}
                playLabel={intl.formatMessage(isPlaying ? PAUSE_AUDIO_TEXT : PLAY_AUDIO_TEXT)}
                playable={true}
                disabled={playbackDisabled}
                onToggle={togglePlay}
            />
        </div>
    );
};

export {
    AudioWave,
    IAudioWaveProps,
};
